import React, { Component } from 'react';
import { NavLink  } from 'reactstrap';
import CreditCardWidget from 'components/PaymentContainer/CreditCardWidget';
import DebitCardWidget from 'components/PaymentContainer/DebitCardWidget';
import DebitCardAtmPinWidget from 'components/PaymentContainer/DebitCardAtmPinWidget';
import NetBankingWidget from 'components/PaymentContainer/NetBankingWidget';
import SavedCardWidget from 'components/PaymentContainer/SavedCardWidget';
import PaylaterWidget from "components/PaymentContainer/PaylaterWidget"
import UpiWidget from 'components/PaymentContainer/UpiWidget';
import WalletsCashWidget from 'components/PaymentContainer/WalletsCashWidget';
import EmiWidget  from 'components/PaymentContainer/EmiWidget';
import BharatQrWidget from 'components/PaymentContainer/BharatQrWidget';
import GrabPayWidget from "components/PaymentContainer/GrabPay";
import WeChatWidget from "components/PaymentContainer/WeChatWidget";
import RmsWidget from "components/PaymentContainer/RmsWidget";
import Card from "components/PaymentContainer/Card";
import Info from 'components/FDModal/info'
import TermsAndCondition from '../TermsAndConditionWidget'

class PaymentView extends Component {

    constructor(props) {
        super(props);
        this.state = {
          modal: false
        };
    
        this.toggle = this.toggle.bind(this);
      }
    
      toggle(type) {
            if(type==="UPI"){
            this.setState({ displayUPIInfo: !this.state.displayUPIInfo });
            }else if (type==="IDEBIT"){
            this.setState({ displayIDEBIT: !this.state.displayIDEBIT });
            }else if (type==="BHARATQR"){
            this.setState({ displayBHARATQR: !this.state.displayBHARATQR });
            }

      }

    switchPaymentView(selectedPayment) {
        const paymentCode = selectedPayment;// ? selectedPayment.code : null
        // console.log("PAYMENT CODE",paymentCode)
        switch(paymentCode) {
            case 'SC':
                return <SavedCardWidget t={this.props.t} changePayment={this.props.changePayment}/>;
            case 'UPI':
                return <UpiWidget t={this.props.t} changePayment={this.props.changePayment}/>
            case 'CREDITCARD':
                return <CreditCardWidget t={this.props.t} />;
            case 'DEBITCARD':
                return <DebitCardWidget t={this.props.t} />;
            case 'IDEBIT':
                return <DebitCardAtmPinWidget t={this.props.t} />;
            case 'NETBANKING':
                return <NetBankingWidget t={this.props.t} />;
            case 'WALLET':
                return <WalletsCashWidget t={this.props.t} />;
            case 'EMI':
                return <EmiWidget t={this.props.t} />;
            case 'BHARATQR':
                return <BharatQrWidget t={this.props.t} />;
            case 'ICICIPAYLATER' : 
                return <PaylaterWidget t={this.props.t}/>;   
            case 'GRABPAY':
                return <GrabPayWidget t={this.props.t}></GrabPayWidget>;
            case 'WECHAT':
                return <WeChatWidget  t={this.props.t}></WeChatWidget>  ;
            case 'RMS':
                return <RmsWidget t={this.props.t}></RmsWidget>
            case 'CARD':
                return <Card t={this.props.t}/>    
            default:
                return <div>Loading...</div>;
        }
    }

    render() {
        const {t, merchantInfo} = this.props
        return(
            
            <>
                {
                    this.props.paymentList.map((paymentType, i) => (
                        <React.Fragment key={i}>
                            <div className={`${paymentType==='BHARATQR' ? 'none-mobile':''} mob-navLink mob-hidden ${this.props.selectedPayment===paymentType ? 'show' : ''}`}>
                                <NavLink  title="" alt="" href="#" onClick={()=> this.props.changePayment(paymentType)}>
                                    { t(paymentType) }
                                    { (paymentType==='UPI' || paymentType==='IDEBIT' || paymentType==='BHARATQR') &&
                                        <span onClick={()=>this.toggle(paymentType)} className="icon-info"></span>
                                    }
                                    <span className="icon-down-arrow"></span>
                                </NavLink>
                            </div>
                            <div className={this.props.selectedPayment===paymentType ? 'active' : 'hidden'}>
                                { this.props.selectedPayment===paymentType && this.switchPaymentView(paymentType) }
                                { merchantInfo && merchantInfo.mrchTNCFlag == "Y" &&
                                    <div className="col-12 pl-md-5 pr-md-5">
                                        <div className="pl-md-5 pr-md-4 mr-md-5 ml-md-5 d-flex justify-content-center">
                                            <TermsAndCondition/>
                                        </div>
                                    </div>
                                }

                            </div>
                        </React.Fragment>
                    ))
                }

                <div>
                    { this.state.displayUPIInfo && <Info message="UPI payment can be done using your Bank App, Google Pay, PhonePe, Paytm, WhatsApp or any BHIM UPI App" /> }
                </div>
                <div>
                    { this.state.displayIDEBIT && <Info message="Make payment via your ATM card. Note: You will be redirected to your bank’s page to enter the ATM PIN / OTP" /> }
                </div>
                <div>
                    { this.state.displayBHARATQR && <Info message="Bharat QR payment can be done using your Bank App, Google Pay, PhonePe, Paytm, WhatsApp or any BHIM UPI App" /> }
                </div>

            </>

        );
    }

}

export default PaymentView;